import { cn } from "@etudescarre/ui";
import { Outlet, useLocation } from "react-router";
import { AdminNav } from "@/features/admin/admin-nav";
import { RequireRoot } from "./require-root";

// Yard detail sub-screens (décloupage, nature travaux, contrats/équipes,
// donneurs d'ordre...) are dedicated full-width screens: the cross-entity
// admin tabs (Chantiers/Entreprises/Contrats/...) don't apply once drilled
// into a specific yard, so hide AdminNav there. The yards list itself
// (/admin/yards) still shows it.
const YARD_DETAIL_PATH = /^\/admin\/yards\/[^/]+/;

// Among yard-detail sub-screens, these own their full bounded layout (fixed
// header/titles, h-full, only their tables scroll — screen-design's "no
// page-level scroll" rule) and must never receive a wheel/trackpad event on
// `main` itself: with `overflow-y-auto`, Safari's elastic bounce visibly
// rubber-bands the whole page (including the "fixed" header) on any scroll
// gesture even though there is zero actual overflow.
// The other yard-detail screen (index "yards/:yardId") still relies on
// normal page scroll and needs `main` itself scrollable.
const SELF_BOUNDED_YARD_PATH =
  /^\/admin\/yards\/[^/]+\/(decoupage|nature-travaux|travaux|donneurs-ordre)(\/|$)/;

export function AdminLayout() {
  const location = useLocation();
  const hideAdminNav = YARD_DETAIL_PATH.test(location.pathname);

  // Yard-detail sub-screens own their bounded layout (fixed header/titles,
  // only their tables scroll): hand them a definite height (h-full, consuming
  // the one Layout already bounds to the viewport). `main` keeps
  // overflow-y-auto so a yard-detail page not yet on this pattern still
  // scrolls under a fixed header, same as YardLayout — except for the
  // self-bounded ones, which need `overflow-hidden` instead (see above).
  if (hideAdminNav) {
    const isSelfBounded = SELF_BOUNDED_YARD_PATH.test(location.pathname);
    return (
      <RequireRoot>
        <div className="flex h-full flex-col overflow-hidden">
          <main
            className={cn(
              "min-h-0 flex-1",
              isSelfBounded
                ? "overflow-hidden"
                : "overflow-y-auto overscroll-none",
            )}
          >
            <Outlet />
          </main>
        </div>
      </RequireRoot>
    );
  }

  return (
    <RequireRoot>
      <div className="flex h-full flex-col">
        <AdminNav />
        <main className="min-h-0 flex-1 overflow-y-auto overscroll-none">
          <Outlet />
        </main>
      </div>
    </RequireRoot>
  );
}
